<template>
  <a-button
    v-if="props.row.status === 'Unverified'"
    class="secondary_medium"
    @click="verifyEmail"
    :loading="loading"
  >
    Verify Email
  </a-button>
</template>

<script setup>
import { ref } from "vue";
import SuperCampaignsService from "@/src/api/SuperCampaignsService.js";
import { message } from "ant-design-vue";

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const loading = ref(false);

const verifyEmail = async () => {
  try {
    loading.value = true;
    const payload = {
      sender_email: props.row.email,
    };

    const response = await SuperCampaignsService.verifySenderEmail(payload);

    if (response?.success) {
      message.success("Verification email sent successfully");
      const event = new CustomEvent("refresh-sender-data");
      window.dispatchEvent(event);
    } else if (response?.message) {
      message.error(response.message);
    } else {
      message.error("Failed to send verification email");
    }
  } catch (error) {
    console.error("Error verifying email:", error);
    message.error("An error occurred while verifying email");
  } finally {
    loading.value = false;
  }
};
</script>
